import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['CheckTogglerStyles-cvaRoot', 'block', 'not-last:mb-1.6', 'cursor-pointer select-none']);

export const cvaCheckbox = cva(['CheckToggler-cvaCheckbox', 'hidden', 'peer']);

export const cvaItem = cva([
  'CheckToggler-cvaItem',
  'relative',
  'flex items-center',
  'min-h-[2.4rem]',
  'sm:pl-5.8 pr-5.8 sm:pr-0',
  'before:w-4.2 before:h-2.4 before:absolute before:right-0 sm:before:right-auto sm:before:left-0 before:top-0 before:bg-cMediumGreyOnWhite before:rounded-[1.2rem] before:transition-colors before:duration-300',
  'after:absolute after:w-2 after:h-2 after:top-0.2 after:right-2 sm:after:right-auto sm:after:left-0.2 after:rounded-full after:bg-cWhite after:transition-transform after:duration-300',
  'peer-checked:after:translate-x-1.8 peer-checked:before:bg-cMediumGreen',
]);

export const cvaBody = cva(['CheckToggler-cvaBody', 'block', 'text-bodyM']);
